import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'

import { DeleteForever, Edit } from '@material-ui/icons'
import DeleteForm from '../Form/Delete'
import EditForm from '../Form/Edit'
import styles from '../hexColors.module.scss'
import PreviewComponent from 'components/Global/Preview'

const HexColors = ({ colors, update, loading }) => {
  const [deleteForm, openDeleteForm] = useState(false)
  const [editForm, openEditForm] = useState(false)
  const [colorId, setColorId] = useState()

  return (
    <div className={styles.hexContent}>
      {colors.map((color, i) => {
        const { __typename, name, ...details } = color
        return (
          <div className={styles.hexardWrapper} key={i}>
            <PreviewComponent
              title={color.name}
              details={details}
              preview={'#' + color.hex}
              componentType="icon"
              previewSize={[80, 80]}
              iconCardWidth={300}
              actions={[
                <IconButton
                  onClick={() => {
                    openEditForm(true)
                    setColorId(i)
                  }}
                  key={1}
                >
                  <Edit />
                </IconButton>,
                <IconButton
                  onClick={() => {
                    openDeleteForm(true)
                    setColorId(i)
                  }}
                  key={2}
                >
                  <DeleteForever />
                </IconButton>,
              ]}
            />
          </div>
        )
      })}{' '}
      {deleteForm && (
        <DeleteForm
          open={deleteForm}
          setOpen={openDeleteForm}
          color={colors[colorId]}
          update={update}
          loading={loading}
        />
      )}
      {editForm && (
        <EditForm
          open={editForm}
          setOpen={openEditForm}
          color={colors[colorId]}
          update={update}
          loading={loading}
        />
      )}
    </div>
  )
}

export default HexColors
